import Link from "next/link";
import { 푸터_Desktop } from "./푸터_Desktop";
import { 헤더_DesktopAB } from "./헤더_DesktopAB";
import 섹션1_이미지1 from "/public/assets/pc/images/pic/img_section1_bg_marketbom1.webp";
import 섹션2_이미지1 from "/public/assets/pc/images/pic/img_section2_marketbom1.webp";
import 섹션2_이미지2 from "/public/assets/pc/images/pic/img_section2_marketbom2.webp";
import 섹션2_이미지3 from "/public/assets/pc/images/pic/img_section2_marketbom3.webp";
import 섹션2_이미지4 from "/public/assets/pc/images/pic/img_section2_marketbom4.png";
import 섹션2_이미지5 from "/public/assets/pc/images/pic/img_section2_marketbom5.webp";
import 화살표_아이콘 from "/public/assets/pc/images/icon/icon_move_link1.webp";
import { 무료체험기간 } from "./데이터/무료체험기간";
import { 링크 } from "./데이터/링크";
import { useTracker } from "./util/Tracker";
import { pipe } from "@mobily/ts-belt";
import { useContext } from "react";
import { GrowthBookCTX, getValue } from "./util/GrowthBookCTX";

export const 마켓봄소개_Desktop = () => {
  const tracker = useTracker();
  const featureFlag = useContext(GrowthBookCTX);
  const simplifiedRegister = pipe(featureFlag, getValue("simplified-register"));

  return (
    <>
      <div id="wrap">
        <헤더_DesktopAB />
        <div id="container" className="service-infomation service-marketbom">
          <h2 className="blind">본문 내용</h2>
          <div
            className="section section1"
            style={{
              background: `url(${섹션1_이미지1.src}) no-repeat center center #fbf9f5`,
            }}
          >
            <h3 className="blind">상단 소개</h3>
            <div className="inner">
              <dl>
                <dt>마켓봄</dt>
                <dd>
                  수발주 기능이 필요한 프랜차이즈, 유통사, 물류사에
                  <br />
                  적합한 유통 수발주 프로그램 입니다.
                </dd>
              </dl>
            </div>
          </div>
          <div className="section section2">
            <div className="inner">
              <h3>아직도 이런 문제를 가지고 계신가요?</h3>
              <div
                className="row type1"
                style={{
                  background: `url(${섹션2_이미지1.src}) no-repeat right center`,
                }}
              >
                <span className="num open-sans">01</span>
                <dl>
                  <dt>
                    복잡한
                    <strong className="bold"> 거래처별 판매 상품 관리</strong>
                    <br />
                    <span className="fc1">
                      마켓봄은 <strong className="bold">간편한 관리</strong>
                    </span>
                  </dt>
                  <dd>
                    브랜드 관리를 통해 거래처에 전체 상품 중<br />
                    판매하고자 하는 일부상품만 노출 시킬 수 있습니다.
                  </dd>
                </dl>
              </div>
              <div
                className="row type2"
                style={{
                  background: `url(${섹션2_이미지2.src}) no-repeat left center`,
                }}
              >
                <span className="num open-sans">02</span>
                <dl>
                  <dt>
                    번거로운 <strong className="bold">세금계산서 발행</strong>
                    <br />
                    <span className="fc1">
                      마켓봄은 <strong className="bold">원클릭 발행</strong>
                    </span>
                  </dt>
                  <dd>
                    출고완료된 주문을 자동 취합하여
                    <br />
                    거래명세표와 비교할 필요없이
                    <br />
                    원클릭으로 세금계산서를 발행합니다.
                  </dd>
                </dl>
              </div>
              <div
                className="row type3"
                style={{
                  background: `url(${섹션2_이미지3.src}) no-repeat right center`,
                }}
              >
                <span className="num open-sans">03</span>
                <dl>
                  <dt>
                    반복되는 장시간의
                    <strong className="bold"> 수발주 취합</strong>
                    <br />
                    <span className="fc1">
                      마켓봄은
                      <strong className="bold"> 주문 즉시 자동 취합</strong>
                    </span>
                  </dt>
                  <dd>
                    매일 반복되던 장시간의 수발주 처리
                    <br />
                    (전화, 문자, 카톡 등)를
                    <strong className="bold"> 거래처의 간편한</strong>
                    <br />
                    <strong className="bold">주문 시스템으로</strong> 즉시 자동
                    취합합니다.
                  </dd>
                </dl>
              </div>
              <div
                className="row type4"
                style={{
                  background: `url(${섹션2_이미지4.src}) no-repeat right center`,
                }}
              >
                <span className="num open-sans">04</span>
                <dl>
                  <dt>
                    외상 거래로 <strong className="bold">미수금 증가</strong>
                    <br />
                    <span className="fc1">
                      마켓봄은 <strong className="bold">미수금 ZERO!</strong>
                    </span>
                  </dt>
                  <dd>
                    <strong className="bold">선결제의 다양한 결제 방식</strong>
                    (가상계좌, 신용카드)과
                    <br />
                    <strong className="bold">미수금 관리 기능</strong>
                    (한도 설정, 결제일 설정, 
                    <br />
                    주문제한, 문자알림)으로
                    <strong className="bold">외상거래를</strong>
                    <br />
                    <strong className="bold">감소</strong>시킬 수 있습니다.
                  </dd>
                </dl>
              </div>
              <div
                className="row type5"
                style={{
                  background: `url(${섹션2_이미지5.src}) no-repeat right center`,
                }}
              >
                <span className="num open-sans">05</span>
                <dl>
                  <dt>
                    실시간 확인이 어렵던{" "}
                    <strong className="bold"> 매출/매입 조회</strong>
                    <br />
                    <span className="fc1">
                      마켓봄은{" "}
                      <strong className="bold"> 모바일앱으로 즉시 확인</strong>
                    </span>
                  </dt>
                  <dd>
                    유통사 주문확인용
                    <strong className="bold"> 모바일 앱 제공</strong>으로
                    <br />
                    실시간으로 매출과 매입의 상세내역까지
                    <br />
                    확인할 수 있습니다.
                  </dd>
                </dl>
              </div>
            </div>
          </div>
          <div className="section section3">
            <div className="inner">
              <h3>다양한 마켓봄의 기능</h3>

              <div className="function-list" style={{ borderRadius: "16px" }}>
                <div className="row type1">
                  <h4>
                    <span className="table-cell">대시보드</span>
                  </h4>
                  <div className="cont">
                    <div className="col">
                      <ul>
                        <li>주간 손익 현황</li>
                        <li>순매출/순매입 추이</li>
                        <li>매출현황</li>
                      </ul>
                    </div>
                    <div className="col">
                      <ul>
                        <li>매입현황</li>
                        <li>이익률 낮은 매출처, 상품 TOP5</li>
                        <li>매출액 감소 매출처 TOP5</li>
                      </ul>
                    </div>
                    <div className="col">
                      <ul>
                        <li>주문건수 감소 매출처 TOP5</li>
                        <li>미수금 많은 매출처 TOP5</li>
                        <li>매출 부진 영업,배송 담당 TOP5</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="row type2">
                  <h4>
                    <span className="table-cell">주문</span>
                  </h4>
                  <div className="cont">
                    <div className="col">
                      <ul>
                        <li>거래처 전용 주문 앱 제공</li>
                        <li>거래처 주문 등록</li>
                        <li>유통사 주문 확인용 앱 제공</li>
                      </ul>
                    </div>
                    <div className="col">
                      <ul>
                        <li>유통사 직접 주문 등록</li>
                        <li>주문 수정, 취소, 삭제</li>
                        <li>주문 대량 등록</li>
                      </ul>
                    </div>
                    <div className="col">
                      <ul>
                        <li>주문 가능 요일 설정</li>
                        <li>휴무일 설정</li>
                        <li>최소 주문 가능 금액 설정</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="row type3">
                  <h4>
                    <span className="table-cell">단가</span>
                  </h4>
                  <div className="cont">
                    <div className="col">
                      <ul>
                        <li>상품에 매출단가, 매입단가 등록</li>
                        <li>단가그룹 무제한 생성</li>
                        <li>단가그룹별 단가관리</li>
                        <li>단가 일괄 수정</li>
                      </ul>
                    </div>
                    <div className="col">
                      <ul>
                        <li>상품별 특단가 관리</li>
                        <li>거래처별 특단가 관리</li>
                        <li>매출전표 원가 정리</li>
                        <li>매출전표 매출가 정리</li>
                      </ul>
                    </div>
                    <div className="col">
                      <ul>
                        <li>매입가 대비 매출가 자동 설정</li>
                        <li>예약단가 설정</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="row type4">
                  <h4>
                    <span className="table-cell">상품</span>
                  </h4>
                  <div className="cont">
                    <div className="col">
                      <ul>
                        <li>개별 상품 등록</li>
                        <li>일괄 상품 등록</li>
                        <li>일괄 상품 수정</li>
                        <li>5단계로 이루어진 카테고리 설정</li>
                      </ul>
                    </div>
                    <div className="col">
                      <ul>
                        <li>상품별 이미지 등록</li>
                        <li>상품별 마감시간 설정</li>
                        <li>판매 중지/재개</li>
                        <li>판매처 노출/비노출</li>
                      </ul>
                    </div>
                    <div className="col">
                      <ul>
                        <li>수동 재고 조정</li>
                        <li>재고처/로케이션 관리</li>
                        <li>상품 그룹 설정(브랜드)</li>
                        <li>추천상품 설정</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="row type5">
                  <h4>
                    <span className="table-cell">거래처</span>
                  </h4>
                  <div className="cont">
                    <div className="col">
                      <ul>
                        <li>개별 거래처 등록</li>
                        <li>일괄 거래처 등록</li>
                        <li>일괄 거래처 수정</li>
                        <li>거래처 아이디 문자 발송</li>
                      </ul>
                    </div>
                    <div className="col">
                      <ul>
                        <li>거래처 무제한 생성</li>
                        <li>거래처별 마감시간 설정</li>
                        <li>거래처별 단가 설정</li>
                        <li>5단계로 이루어진 카테고리 설정</li>
                      </ul>
                    </div>
                    <div className="col">
                      <ul>
                        <li>거래처 그룹 설정(브랜드)</li>
                        <li>주문 전용 모바일 앱 제공</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="row type6">
                  <h4>
                    <span className="table-cell">재고</span>
                  </h4>
                  <div className="cont">
                    <div className="col">
                      <ul>
                        <li>상품 재고 현황</li>
                        <li>재고처별 재고 현황</li>
                      </ul>
                    </div>
                    <div className="col">
                      <ul>
                        <li>실사 재고 조정</li>
                        <li>적정 재고 관리</li>
                      </ul>
                    </div>
                    <div className="col">
                      <ul>
                        <li>재고처 간 재고 이동</li>
                        <li>월별 재고 마감</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="row type7">
                  <h4>
                    <span className="table-cell">미수금 관리</span>
                  </h4>
                  <div className="cont">
                    <div className="col">
                      <ul>
                        <li>거래처별 결제 방법 설정</li>
                        <li>거래처별 가상계좌 무료 제공</li>
                        <li>카드 결제 제공</li>
                      </ul>
                    </div>
                    <div className="col">
                      <ul>
                        <li>거래처별 외상한도 설정</li>
                        <li>거래처별 결제일 설정</li>
                        <li>거래처별 주문 차단 설정</li>
                      </ul>
                    </div>
                    <div className="col">
                      <ul>
                        <li>미수 거래처 자동 알림</li>
                        <li>미수 현황 알림</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="row type8">
                  <h4>
                    <span className="table-cell">회계</span>
                  </h4>
                  <div className="cont">
                    <div className="col">
                      <ul>
                        <li>회계 등록</li>
                        <li>손익현황 확인</li>
                      </ul>
                    </div>
                    <div className="col">
                      <ul>
                        <li>결제 방법별 원장</li>
                        <li>일일 마감</li>
                      </ul>
                    </div>
                    <div className="col">
                      <ul>
                        <li>세금계산서 양식 다운로드</li>
                        <li>세금계산서 비교</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="row type9">
                  <h4>
                    <span className="table-cell">거래내역 변경 현황</span>
                  </h4>
                  <div className="cont">
                    <div className="col">
                      <ul>
                        <li>거래전표 변경 현황 제공</li>
                        <li>수주 변경 현황 제공</li>
                      </ul>
                    </div>
                    <div className="col">
                      <ul>
                        <li>발주 변경 현황 제공</li>
                        <li>세금계산서 변경 현황 제공</li>
                      </ul>
                    </div>
                    <div className="col">
                      <ul>
                        <li>거래처 잔액 변경 현황 제공</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="row type10">
                  <h4>
                    <span className="table-cell">자료 일괄 등록</span>
                  </h4>
                  <div className="cont">
                    <div className="col">
                      <ul>
                        <li>상품 정보 등록/수정</li>
                        <li>상품 단가 설정</li>
                        <li>상품 특단가 설정</li>
                      </ul>
                    </div>
                    <div className="col">
                      <ul>
                        <li>상품 브랜드 설정</li>
                        <li>거래처 등록/수정</li>
                        <li>거래전표 등록/삭제</li>
                      </ul>
                    </div>
                    <div className="col">
                      <ul>
                        <li>회계전표 등록/삭제</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="row type11">
                  <h4>
                    <span className="table-cell">서비스</span>
                  </h4>
                  <div className="cont">
                    <div className="col">
                      <ul>
                        <li>메뉴얼 제공</li>
                        <li>공지사항 등록</li>
                        <li>화면/인쇄 설정 제공</li>
                      </ul>
                    </div>
                    <div className="col">
                      <ul>
                        <li>거래명세표 커스텀</li>
                        <li>직원별 계정 생성</li>
                        <li>다중 구조 지원</li>
                      </ul>
                    </div>
                    <div className="col">
                      <ul>
                        <li>하위 유통 구조 지원</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="btn-wrap">
                <Link
                  href={
                    simplifiedRegister
                      ? 링크.마켓봄_간편가입_실험_링크_PC
                      : 링크.마켓봄_회원가입
                  }
                  style={{
                    background: `url(${화살표_아이콘.src}) no-repeat 463px center #fe6b37`,
                  }}
                  onClick={() =>
                    tracker.trackingClick({
                      depth1: "MARKETBOM",
                      depth2: "회원가입",
                      depth3: "마켓봄",
                      indicator: "회원가입",
                    })
                  }
                >
                  마켓봄 시작하기
                  <span>{`결제없이! ${무료체험기간.마켓봄} 무료 이용하기`}</span>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <푸터_Desktop />
      </div>
    </>
  );
};
